export const eventCategories = {
    DRAWER: 'drawer'
};

export const drawerActions = {
    OPEN: 'open_drawer',
    CLICK_LINK: 'click_drawer_link'
};

export const drawerEventParams = {
    RESOURCE_TITLE: 'resource_title',
    RESOURCE_LINK: 'resource_link',
    STATION_ID: 'station_id',
    STATION_NAME: 'station_name',
    STATION_DESCRIPTION: 'station_description',
    REGION_NAME: 'region_name',
    ZONE_NAME: 'zone_name'
};
